import style from "./new-paid-seats-modal.module.css";
import StyledButton from "frontend/ui-components/styled-button";
import React, { useEffect } from "react";
import { InviteFailedEmailsList } from "frontend/ui-components/invite-emails";
import useStateValue from "frontend/state/value";
import { Action } from "frontend/state";
import classNames from "classnames";

export default function NewPaidSeatsModal({
  onDismiss,
  addedSeats,
  invitedCount,
  failedEmails,
}: {
  onDismiss: () => void;
  addedSeats: number;
  invitedCount: number;
  failedEmails: string[];
}) {
  const [{ user }, dispatch] = useStateValue();

  const buttonStyle = {
    width: 100,
    borderRadius: 6,
    height: 32,
    letterSpacing: 0.124,
    alignSelf: "end",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
  };

  useEffect(() => {
    if (addedSeats && user) {
      const seats_count = Number(user?.planInfo?.seats_count ?? 0) + Number(addedSeats);
      const updatedUser = { ...user, planInfo: { ...user?.planInfo }, seats_count };
      dispatch({ type: Action.UpdatedUser, payload: updatedUser });
    }
  }, []);

  function renderContent(invitedCount?: number, addedSeats?: number) {
    const inviteSentMessage =
      invitedCount && invitedCount > 1 ? `${invitedCount} new invites sent,` : `${invitedCount} new invite sent,`;
    const addedSeatsMessage =
      addedSeats && addedSeats > 1 ? `${addedSeats} new paid seats` : `${addedSeats} new paid seat`;
    return (
      <span>
        {inviteSentMessage} <br />
        <b>{addedSeatsMessage}</b> added.
      </span>
    );
  }

  function renderNewPaidSeatsModal() {
    const failedCount = failedEmails?.length;

    return (
      <div className={classNames(style.container, style.newHomePageContainer)}>
        <div className={classNames(style.internalContainer, style.newHomePageInternalContainer)}>
          <div className={classNames(style.successHeader, style.newHomePageSuccessHeader)}>
            Invites sent and seats added
          </div>
          <div className={classNames(style.successBody, style.newHomePageSuccessBody)}>
            {renderContent(invitedCount, addedSeats)}
          </div>
          {failedCount && failedCount > 0 ? (
            <div className={style.failedContainer}>
              <InviteFailedEmailsList failedEmails={failedEmails} />
            </div>
          ) : null}
          <div className={style.successButtonContainer}>
            <StyledButton title="Got it" onClick={() => onDismiss()} customStyle={buttonStyle} />
          </div>
        </div>
      </div>
    );
  }

  return renderNewPaidSeatsModal();
}
